import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import React from 'react';
import SimpleDialog from '../../Components/Atoms/SimpleDialog/';
import Typography from '@material-ui/core/Typography';

interface IRemoveButton {
    confirmationTitle: string;
    handleRemove: any;
}
const useStyles = makeStyles(theme => ({
    root: {
        cursor: 'pointer',
        display: 'inline-block',
        position: 'absolute',
        right: 0,
        width: '25px',
        height: '25px',
        color: theme.palette.common.white,
        borderRadius: '25px',
        transform: 'translate(50%, -50%)',
        backgroundColor: theme.palette.error.main,
        zIndex: 3,
    },
}));
const RemoveButton = ({ confirmationTitle, handleRemove }: IRemoveButton) => {
    const classes = useStyles();
    const [confirmationDialog, setConfirmationDialog] = React.useState(false);

    const handleOkClick = () => {
        setConfirmationDialog(false);
        handleRemove();
    };
    const handleCancelConfirmation = () => {
        setConfirmationDialog(false);
    };

    const triggerRemove = () => {
        setConfirmationDialog(true);
    };
    return (
        <React.Fragment>
            <SimpleDialog
                onCancel={handleCancelConfirmation}
                onOk={handleOkClick}
                open={confirmationDialog}
                title={confirmationTitle}
            >
                <Typography component="p" variant="body1">
                    Are you sure you want to remove this image?
                </Typography>
            </SimpleDialog>
            <Icon classes={{ root: classes.root }} onClick={triggerRemove}>
                remove
            </Icon>
        </React.Fragment>
    );
};

export default RemoveButton;
